import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';

// --------------------------------------------
// Registering Syncfusion license key
// --------------------------------------------
registerLicense('NRAiBiAaIQQuGjN/V0Z+XU9EaFtFVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RdEVnW3lccHBWRWRUVUJ2');

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
};


if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}


// ---------------------------------------------------------------------
// Console output <-- SILENCE on Production
// Suppress ALL console channels (log/info/debug/warn/error), not just log.
// Sensitive data (bearer tokens, encryption keys, decrypted evidence) must
// never reach DevTools. console.error was previously left live, leaking
// tokens in prod. See SECURITY-AUDIT-2026-07.md (CR-1).
// ---------------------------------------------------------------------
if (environment.hideConsoleLog) {
  // check if window exists, if you render backend window will not be available
  if (window) {
    const noop = function () { };
    window.console.log = noop;
    window.console.info = noop;
    window.console.debug = noop;
    window.console.warn = noop;
    window.console.error = noop;
  }
} 